import { translate } from './translation.js'

const createModel = () => {

	const data = {}
	const listeners = []

	const set = (key, val) => {
		data[key] = val
		updateListeners(key, val)
	}

	const updateListeners = (key, val) => {
		listeners.forEach(listener => {
			if (listener.key && listener.key === key) listener.callback(val)
			if (listener.key === undefined) listener.callback(key, val)
		})
	}

	const subscribe = (keyOrCallback, callback = undefined) => {
		if (typeof keyOrCallback === 'string' && typeof callback === 'function') 
			listeners.push({ key : keyOrCallback, callback })
		if (typeof keyOrCallback === 'function' && callback === undefined) 
			listeners.push({ key : undefined, callback : keyOrCallback })
	}

	return { 
		data : () => data, 
		set, 
		subscribe 
	}
}

const sort = (attr = 'data-filter-time', asc = true) => {
	return (a, b) => {
		if (a.getAttribute(attr) === b.getAttribute(attr)) return 0
		const order = (a.getAttribute(attr) > b.getAttribute(attr)) ? 1 : -1
		return asc ? order : -order;
	}
}

const show = (items, { time }, parent, noResultsEl, fragment) => {

	const currentDate = new Date().toISOString()

	const sortMap = {
		'all' : sort(false),
		'past' : sort(false),
		'future' : sort(true),
	}
	
	items.sort(sortMap[time] || sort());

	items.map(item => {
		const date = item.getAttribute('data-filter-time')
		const past = (currentDate > date)
		const future = (currentDate <= date)


		const timeMatch = 
			(time === 'all') || 
			(time === 'past' && past) ||
			(time === 'future' && future)

		const matched = (timeMatch)

		// add each child in order (sorts visually)
		// put non-matching els into a document fragment
		;(matched ? parent : fragment).appendChild(item)
	})

	const results = parent.children.length
	noResultsEl.innerHTML = results ? '' : status(results, { time })
}

const status = (count, { time }) => {

	const noEventsFound = translate('No %s found')
	const showing = translate('Showing')
	const upcomingEvent = translate('upcoming event')
	const upcomingEvents = translate('upcoming events')
	const pastEvent = translate('past event')
	const pastEvents = translate('past events')
	const event = translate('event')
	const events = translate('events')

	const eventType = (() => {
		if (time === 'future') return (count === 1) ? upcomingEvent : upcomingEvents
		if (time === 'past') return (count === 1) ? pastEvent : pastEvents
		return (count === 1) ? event : events
	})()

	if (!count) return `<p>${noEventsFound.replace('%s', eventType)}</p>`
	return `
		<p>${showing} <strong>${count}</strong> ${eventType}</p>
	`
}

export default () => {

	const list = document.querySelector('.js-events-filter-list')
	const items = [...document.querySelectorAll('.js-events-filter-item')]
	const timeButtons = [...document.querySelectorAll('[data-events-filter-set-time]')]
	const noResultsEl = document.querySelector('[data-events-no-results]')
	const frag = document.createDocumentFragment()

	if (!list || !items.length || !timeButtons.length) return
	
	// model
	const model = createModel()

	// on change

	model.subscribe('time', function(newTime) {
		timeButtons.forEach(button => button.classList.remove('active'))
		const current = timeButtons.filter(button => button.getAttribute('data-events-filter-set-time') === newTime).shift()
		current && current.classList.add('active')
		show(items, model.data(), list, noResultsEl, frag)
	})


	// event handlers

	timeButtons.map(button => {
		button.addEventListener('click', e => {
			model.set('time', e.currentTarget.getAttribute('data-events-filter-set-time'))
		})
	})


	// init

	function setFromDOM() {
		// time
		const button = timeButtons.filter(button => button.classList.contains('active'))
		button.length && model.set('time', button[0].getAttribute('data-events-filter-set-time'))
	}
	setFromDOM()
}